import classNames from 'classnames'
import * as React from 'react'

interface IErrorBoundaryProps { 
    small?: boolean
}
interface IErrorBoundaryState {
    hasError: boolean
}

class ErrorBoundary extends React.Component<IErrorBoundaryProps, IErrorBoundaryState> {
    constructor(props: IErrorBoundaryProps) {
        super(props)

        this.state = { hasError: false }
    }

    static getDerivedStateFromError(error: any) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error: any, errorInfo: any) {
        // You can also log the error to an error reporting service
        // logErrorToMyService(error, errorInfo);
        console.log("Error", error )
        console.log("Error info ", errorInfo )
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return (<div className={classNames("error-boundary",{"small": this.props.small} )} >
                <div className="overlay">
                    <div className="icon-container">
                        <div className="icon"></div>
                    </div>

                    <div className="message">
                        <div className="title">Aw, Snap!</div>
                        <div className="sub-title">Something went wrong</div>
                    </div>
                </div>
            </div>);
        }

        return this.props.children;
    }
}

export default ErrorBoundary